if (typeof PickupAvailabilityCompact !== "function") {
  class PickupAvailabilityCompact extends HTMLElement {
    constructor() {
      super();
      this.classList.add("active");

      const widgetIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.fetchAvailability(this.dataset.variantId);
      };
      new IntersectionObserver(widgetIntersection.bind(this), {
        rootMargin: "0px 0px 50px 0px",
      }).observe(this);

      this.storeSelector = document.querySelector(
        "store-selector[data-main-selector]"
      );
      window.addEventListener("load", () => {
        if (this.storeSelector) {
          this.storeSelector.addEventListener("storechanged", (e) => {
            this.fetchAvailability(
              this.dataset.variantId,
              this.dataset.productId
            ).bind(this);
          });
        }
      });
    }

    async fetchAvailability(variantId, productId) {
      const response = await fetch(
        "https://api-us.zapiet.com/v1.0/pickup/locations?shop="+ zapietShopUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            shoppingCart: [
              {
                variant_id: variantId,
                product_id: productId,
                quantity: 1,
              },
            ],
          }),
        }
      );
      const data = await response.json();
      let resultSpan = this.querySelector(".alert--circle-loading");
      resultSpan?.classList.remove("alert--circle-loading");
      const selectedStore = localStorage.getItem("selected-store");
      if (selectedStore == null || selectedStore == "") {
        resultSpan.innerText = `Choose a store to see  availability`;
        return;
      }
      let foundFlag = false;
      resultSpan.classList.remove('alert--note')
      data.locations.forEach((location) => {
        if ((location.company_name == selectedStore)) {
          resultSpan.classList.add('alert--success')
          resultSpan.innerHTML = `<span class="bullet-circle"></span><span>Available for pickup at ${selectedStore}</span>`;
          foundFlag = true;
          return;
        }
      });
      if (!foundFlag) {
        resultSpan.classList.add('alert--error')
        resultSpan.innerHTML = `<span class="bullet-circle"></span><span>Out of stock at ${selectedStore}</span>`;
      }
    }
  }

  if (typeof customElements.get("pickup-availability-compact") == "undefined") {
    customElements.define(
      "pickup-availability-compact",
      PickupAvailabilityCompact
    );
  }
}

if (typeof PickupAvailabilityExtended !== "function") {
  class PickupAvailabilityExtended extends HTMLElement {
    constructor() {
      super();
      this.classList.add("active");
      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      const variantSectionUrl = `${this.dataset.baseUrl}/variants/${variantId}/?section_id=helper-pickup-availability-extended`;

      fetch(variantSectionUrl)
        .then((response) => response.text())
        .then((text) => {
          this.renderPreview(text);

          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(".shopify-section");
        })
        .catch((e) => {
          console.log("catch :" + e);
        });
    }
  }

  if (
    typeof customElements.get("pickup-availability-extended") == "undefined"
  ) {
    customElements.define(
      "pickup-availability-extended",
      PickupAvailabilityExtended
    );
  }
}